import { Component }       from '@angular/core';
import { ActivatedRoute }  from '@angular/router';
import { Router }  from '@angular/router';
import { Location }        from '@angular/common';

import { DoctorService } from '../../services/doctors/doctor.service';

import { UserDetailComponent } from '../../users/detail/user-detail.component';

import { AppConfig } from '../../app.config';

import * as _ from 'lodash';
import * as moment from 'moment';
import { forEach, map, update } from 'lodash';
import { SpecialtiesService } from '../../services/specialties/specialties.service';
import { ProviderService } from '../../services/providers/provider.service';
import { CountryService } from '../../services/country/country.service';

import { Http, Response, ResponseContentType } from '@angular/http';
import { Auth } from '../../services/auth.service';


@Component({
  moduleId: module.id,
  selector: 'my-doctor-detail',
  templateUrl: 'doctor-detail.component.html',
  styleUrls: [ '../../users/detail/user-detail.component.css' ]
})

export class DoctorDetailComponent extends UserDetailComponent {

  constructor(
    protected doctorService: DoctorService,
    protected route: ActivatedRoute,
    protected location: Location,
    protected router: Router,
    protected config: AppConfig,
    protected specialtiesService:SpecialtiesService,
    protected providerService:ProviderService,
    protected countryService:CountryService,
    protected auth: Auth
  ) { super(doctorService, route, location);
  }


  wh = []
  newWH={from:new Date(),to:new Date()}
  addWH:boolean=false;
  selectedDay:any;
  days=['D','L','M','Mi','J','V','S'];
  index:any; //para delete wh

  addedWh:any[]=[]
  deletedWh:any[]=[]
  countries:any[]

  enrollmentTypes = ["MP","MN","OP","ON", "CRM", "MM", "RM", "RP", "SPM", "CMP", "Lic.", "CP", "TP", "CI", "Nro. Colegiado"]
  selectedEnrollmentType;
  registeredInMedikit;

  enrollmentProv = [
    {id:"A", name:"Salta"},
    {id:"B", name:"Buenos Aires"},
    {id:"C", name:"Capital Federal" },
    {id:"D", name:"San Luis"},
    {id:"E", name:"Entre Ríos"},
    {id:"F", name:"La Rioja"},
    {id:"G", name:"Santiago del Estero"},
    {id:"H", name:"Chaco"},
    {id:"J", name:"San Juan"},
    {id:"K", name:"Catamarca"},
    {id:"L", name:"La Pampa"},
    {id:"M", name:"Mendoza"},
    {id:"N", name:"Misiones"},
    {id:"P", name:"Formosa"},
    {id:"Q", name:"Neuquén"},
    {id:"R", name:"Río Negro"},
    {id:"S", name:"Santa Fe"},
    {id:"T", name:"Tucumán"},
    {id:"U", name:"Chubut"},
    {id:"V", name:"Tierra del Fuego"},
    {id:"W", name:"Corrientes"},
    {id:"X", name:"Córdoba"},
    {id:"Y", name:"Jujuy"},
    {id:"Z", name:"Santa Cruz"},
    {id: "BR", name:"Brasil"},
    {id: "CO", name:"Colombia"},
    {id: "CE", name:"Ecuador"},
    {id: "ES", name:"España"},
    {id: "MX", name:"México"},
    {id: "PR", name:"Paraguay"},
    {id: "PE", name:"Perú"},
    {id: "PT", name:"Portugal"},
    {id: "UY", name:"Uruguay"},
  ];

  MexicoStates = [
    { name: "AGUASCALIENTES", value: "AG" },
    { name: "BAJA CALIFORNIA", value: "BC" },
    { name: "BAJA CALIFORNIA SUR", value: "BS" },
    { name: "CAMPECHE", value: "CM" },
    { name: "CHIAPAS", value: "CS" },
    { name: "CHIHUAHUA", value: "CH" },
    { name: "COAHUILA", value: "CO" },
    { name: "COLIMA", value: "CL" },
    { name: "CIUDAD DE MEXICO", value: "CX" },
    { name: "ESTADO DE MEXICO", value: "ME" },
    { name: "DURANGO", value: "DG" },
    { name: "GUANAJUATO", value: "GT" },
    { name: "GUERRERO",	value: "GR" },
    { name: "HIDALGO", value: "HG" },
    { name: "JALISCO", value:	"JA" },
    { name: "MICHOACAN", value:	"MI" },
    { name: "MORELOS", value:	"MO" },
    { name: "NAYARIT", 	value: "NA" },
    { name: "NUEVO LEON", value: "NL" },
    { name: "OAXACA", value: "OA" },
    { name: "PUEBLA", value: "PB"	},
    { name: "QUERETARO", value: "QE" },
    { name: "QUINTANA ROO", value: "QR" },
    { name: "SAN LUIS POTOSI", value: "SL" },
    { name: "SINALOA", value: "SI" },
    { name: "SONORA", value: "SO" },
    { name: "TABASCO", value: "TB" },
    { name: "TAMAULIPAS", value: "TM" },
    { name: "TLAXCALA", value: "TL" },
    { name: "VERACRUZ", value: "VE" },
    { name: "YUCATAN", value: "YU" },
    { name: "ZACATECAS", value:	"ZA" }
  ]

  medikitData = {};

  selectedEnrollmentProv;

  /*ALERTAS*/
  alertBlank:boolean=false;
  alertHour:boolean=false;
  alertDay:boolean=false;
  alertExist:boolean=false;
  alertTime:boolean=false;
  alertDelete:boolean=false;

  allSupportedLanguages = []

  needsAutomaticActivation: boolean = true;

  priorityCountryEmptyItemText:string="All countries";
  priorityCountry:string= this.priorityCountryEmptyItemText;

  hasWriteDoctorPermission:boolean = false;
  hasWriteProviderPermission:boolean = false;

  closeAlertBlank(){
    this.alertBlank=false;
  }
  closeAlertHour(){
    this.alertHour=false;
  }
  closeAlertDay(){
    this.alertDay=false;
  }
  closeAlertExist(){
    this.alertExist=false;
  }
  closeAlertTime(){
    this.alertTime=false;
  }
  closeAlertDelete(){
    this.alertDelete=false;
  }
  /*alertas*/


  checkBoxDays= [
    { day: 'D',    selected: false },
    { day: 'L',   selected: false },
    { day: 'Ma',     selected: false },
    { day: 'Mi', selected: false },
    { day: 'J',   selected: false },
    { day: 'V',     selected: false },
    { day: 'S', selected: false }
  ];

  specialties;

  protected getDefaultUserImageUrl(): string {

    return 'http://www.healthqube.com/Images/Blog/20151228_19_20_15_Default-Doctor.png';
  };

  changeSignature($ev:any){
    var inputValue = $ev.target;
    let file = inputValue.files[0];
    var formData =new FormData();
    formData.append("signature",  file);
    this.doctorService.updateImage(this.updatedUser.id,formData)

  }
  fillObject(){
    this.hasWriteDoctorPermission = this.auth.hasWriteDoctorPermission();
    this.hasWriteProviderPermission = this.auth.hasWriteProviderPermission();

    if(!this.hasWriteDoctorPermission){
      $(document).ready (() => {
        var inputs = document.getElementsByTagName('input');
        var selects = document.getElementsByTagName('select');
        Array.from(inputs).forEach((input) => input.setAttribute("disabled",""));
        Array.from(selects).forEach((select) => select.setAttribute("disabled",""));
      })
    }

    //fill working hour array for the html
    if (this.updatedUser !== undefined){

      this.registeredInMedikit = !!this.updatedUser.medikitDoctorToken;
      this.medikitData["country"] = this.updatedUser.country || "";
      this.medikitData["state"] = this.updatedUser.state || "";
      this.medikitData["billingAddress"] = this.updatedUser.billingAddress || "";
      this.medikitData["institution"] = this.updatedUser.institution || "";
      this.medikitData["city"] = this.updatedUser.city || "";
      this.medikitData["postalCode"] = this.updatedUser.postalCode || "";
      this.medikitData["mobilePhone"] = this.updatedUser.mobilePhone || "";
      this.medikitData["birthDate"] = this.updatedUser.birthDate || "";
      this.medikitData["documents"] = {};

      this.updatedUser.active =  this.updatedUser.active==undefined  || this.updatedUser.active
      var arr = []
      var obj = this.updatedUser.workingHours
      console.log('--------------WH----------------')
      console.log(obj)
     // console.log('------------bucle---------------')
      for (var prop in obj) {
        //console.log(prop+', '+obj[prop])
        arr.push({key:prop,value:obj[prop]})
      }
     // console.log('-------------ARRAY-------------')
     // console.log(arr)


      for (let i=0;i<this.days.length;i++){
        this.wh.push({day:this.days[i],available:false,hours:[],i:i});
      }
     // console.log('-------------MI WH-------------')
     // console.log(this.wh)

      for (let i=0;i<arr.length;i++){
        for (let j=0;j<arr[i].value.length;j++){
          this.wh[arr[i].value[j]].available=true
          this.wh[arr[i].value[j]].hours.push(arr[i].key);
        }
      }

      this.selectedEnrollmentType = this.enrollmentTypes.indexOf(this.updatedUser.enrollmentType)
      this.selectedEnrollmentProv = this.enrollmentProv.findIndex((element)=> {return element.id === this.updatedUser.enrollmentProv})

     // console.log('-------------WH FINAL-------------')
     // console.log(this.wh)
     if (_.isUndefined(this.updatedUser.canSignPrescription)) this.updatedUser.canSignPrescription = false;
     if (_.isUndefined(this.updatedUser.canAttendToPendingConsultations)) this.updatedUser.canAttendToPendingConsultations = false;
     if (_.isUndefined(this.updatedUser.useP2P)) this.updatedUser.useP2P = false;
     if (_.isUndefined(this.updatedUser.ladDoctor)) this.updatedUser.ladDoctor = false;
     if (_.isUndefined(this.updatedUser.canAttendAppointments)) this.updatedUser.canAttendAppointments = false;
     if (_.isUndefined(this.updatedUser.usesBukeala)) this.updatedUser.usesBukeala = false;
     if (_.isUndefined(this.updatedUser.canMonitoring)) this.updatedUser.canMonitoring = false;
     if (_.isUndefined(this.updatedUser.priority)) this.updatedUser.priority = false;

     this.providerService.getProviderLanguages().then((supportedLanguages) =>{
      this.allSupportedLanguages = supportedLanguages;
    })

     this.getSpecialties()
     this.getCountries()
    }
  }

  getCountries(){
    this.countryService.getAll().then((countries) => {
      this.countries = countries;
    });
  }

  getSpecialties(){
    this.specialtiesService.getAll().then((response)=>{
      this.specialties=response
      let docSpecialtiesId = this.updatedUser.specialties.map(docSpecialty => docSpecialty.id)
      this.specialties.forEach(specialty => {
        specialty.selected = docSpecialtiesId.includes(specialty.id)
      });
    })
  }

  selectDay(day){
    this.selectedDay=day;
  }
  addNewWH(){
    this.addWH=true;
  }

  deleteWH(index){
    this.index=index;
    this.alertDelete=true;

  }

  showCalls(){
    this.router.navigate([ '/doctor/' + this.user.id +'/calls' ]);
  }


  save(): void {

    let updatedFields: any = this.getUpdatedFields();

    if(this.enrollmentTypes[this.selectedEnrollmentType]!=undefined)
      updatedFields.enrollmentType = this.enrollmentTypes[this.selectedEnrollmentType];

    if(this.enrollmentProv[this.selectedEnrollmentProv]!=undefined)
      updatedFields.enrollmentProv = this.enrollmentProv[this.selectedEnrollmentProv]['id'];

    if (_.isEmpty(updatedFields) && this.url==undefined) {
      this.noChangesAlert = true;
      return;
    }
    this.userService.update(this.user.id, updatedFields)
    .then(() =>
    location.reload())
  }


  submitWH(){
    this.alertBlank=false;
    this.alertDay=false;
    this.alertExist=false;
    this.alertHour=false;
    this.alertTime=false;

    let from:any = moment(this.newWH.from).format('HH:mm')
    let to:any = moment(this.newWH.to).format('HH:mm')
    if (typeof(from)!='string' || typeof(to)!='string'){
      this.alertBlank=true
      return
    }
    if (from==to){
      this.alertHour=true;
      return
    }

    if (moment(from,'HH:mm') > moment(to,'HH:mm')){
      this.alertTime=true;
      return
    }


    let finalDays:any[]=[]
    for (let i=0;i<this.checkBoxDays.length;i++){
      if (this.checkBoxDays[i].selected==true) {
        finalDays.push(i)
      }
    }
    this.alertDay = finalDays.length == 0
    if (this.alertDay){
      return;
    }

    if (!this.isPossible(from,to,finalDays)){
        this.alertExist=true;
        return;
      }

    from = moment(from,'HH:mm').format('HH.mm')
    to = moment(to,'HH:mm').format('HH.mm')
    let wh=from+'-'+to
    this.addedWh.push({hour:wh,days:finalDays})
    //Para que se actualice la pantalla con el nuevo working hour
    this.whChanged=true;
    for(let i=0;i<finalDays.length;i++){
      this.wh[finalDays[i]].available=true
      this.wh[finalDays[i]].hours.push(wh)
    }
  }

  delete(){
    this.whChanged=true
    let daysOfHour = this.updatedUser.workingHours[this.selectedDay.hours[this.index]]
    this.wh[this.selectedDay.i].hours.splice(this.index,1)
    if (this.wh[this.selectedDay.i].hours.length==0){
      this.wh[this.selectedDay.i].available=false
      this.selectedDay=undefined
    }

  }

  isPossible(newFrom,newTo,days:any[]):boolean{
    let hours:any[]
    let from,to
    for (let i=0;i<days.length;i++){
      hours=this.wh[days[i]].hours
      for (let j=0;j<hours.length;j++){
        from=hours[j].slice(0,5)
        to=hours[j].slice(6,11)
        from=moment(from,'HH.mm').format('HH:mm')
        to=moment(to,'HH.mm').format('HH:mm')

        // a-si el nuevo horario esta entre la working hour
        if (from >= newFrom && from < newTo) return false
        if (to > newFrom && to <=newTo) return false

        // b-si la working hour esta entre el nuevo horario
        if (newFrom >= from && newFrom < to) return false
        if (newTo > from && newTo <=to) return false
      }
    }
    return true
  }

  protected getUpdatedFields(): any {

    let updatedFields = {};
    let self = this;
    _.each(self.updatedUser, function (value: any, key: string) {

      if (key=='workingHours' && self.whChanged){
        updatedFields[key] = self.getWhFormat();
      }
      if (self.user[key] !== value) {

        updatedFields[key] = value;
      }


    });

    updatedFields['mainSpecialty'] = this.updatedUser.mainSpecialty.realId;
    let specialtiesToUpdate = []
    this.specialties.forEach(specialty => {
      if(specialty.selected) specialtiesToUpdate.push(specialty.id)
    });
    updatedFields['specialties'] = specialtiesToUpdate;

    return updatedFields;
  }

  getWhFormat(){
    let updated={}
    for (let i=0;i<this.wh.length;i++){
      for (let j=0;j<this.wh[i].hours.length;j++){
        if (!updated[this.wh[i].hours[j]]) updated[this.wh[i].hours[j]]=[i]
        else updated[this.wh[i].hours[j]].push(i)
      }
    }
    //console.log(updated)
    return updated
  }

  goBack(){
    this.location.back()
  }

  searchInAmplitude(){
      window.open('https://analytics.amplitude.com/org/28301/project/'+this.config.get('AMPLITUDE_PROJECT_ID')+'/search/'+this.user.auth0_user, '_blank');
  }

  isSelectedLanguage(language){
    var lang = this.user.supportedLanguages.find(o => o.id == language.id)
    return !_.isUndefined(lang)
  }

  chooseSupportedLanguage(ev, language){
    var selectedLanguage = ev.target.checked;
    if(selectedLanguage) return this.addLanguage(language)
    return this.removeLanguage(language)
  }

  addLanguage = function(language:any){
    this.doctorService.addLanguage(this.user.id,language.id).then(() =>{
      this.provider.supportedLanguages.push(language)
    })
  }

  removeLanguage(language:any){
    this.doctorService.removeLanguage(this.user.id,language.id).then(() =>{
      this.user.supportedLanguages = this.user.supportedLanguages.filter(l => l.id !== language.id)
    })
  }

  addDoctorToAllProvidersAndPriorities(){
    let priorityCountryParam = (!this.priorityCountry || this.priorityCountry == "" || this.priorityCountry == this.priorityCountryEmptyItemText) ? null : this.priorityCountry;
    let isDirty = true
    let updatedFields: any = this.getUpdatedFields();
    if(this.enrollmentTypes[this.selectedEnrollmentType]!=undefined)
      updatedFields.enrollmentType = this.enrollmentTypes[this.selectedEnrollmentType];

    if(this.enrollmentProv[this.selectedEnrollmentProv]!=undefined)
      updatedFields.enrollmentProv = this.enrollmentProv[this.selectedEnrollmentProv]['id'];

    if (_.isEmpty(updatedFields) && this.url==undefined) {
      isDirty = false;
    }

    if (confirm("Do you want to save any changes before adding this doctor to all providers and priorities?")){
      this.userService.update(this.user.id, updatedFields)
      .then(() => {
        if (confirm("Do you want to add this doctor to all providers and priorities?")){
          this.providerService.addDoctorToAllProvidersAndPriorities(this.user.id, priorityCountryParam).then((response)=>{
            window.location.reload();
          }).catch((err:Response)=>{
            alert(err.json().message);
          })
        }
      }
      )
    }
    else {
      if (confirm("Do you want to add this doctor to all providers and priorities?")){
        this.providerService.addDoctorToAllProvidersAndPriorities(this.user.id, priorityCountryParam).then((response)=>{
          window.location.reload();
        }).catch((err:Response)=>{
          alert(err.json().message);
        })
      }
    }
  }

  removeDoctorFromAllProvidersAndPriorities(){
    if (confirm("Do you want to remove this doctor from all providers and priorities?")){
      this.providerService.removeDoctorFromAllProvidersAndPriorities(this.user.id).then((response)=>{
        window.location.reload();
      }).catch((err:Response)=>{
        alert(err.json().message);
      })
    }
  }

  saveMedikitData() {
    const missingMedikitData = this.missingMedikitData();
    const missingDoctorData = this.missingDoctorRequiredData();

    this.medikitData["birthDate"] = moment(this.medikitData["birthDate"]).format("YYYY-MM-DD HH:mm:ss")

    if(missingMedikitData || missingDoctorData) {

      if(missingMedikitData) alert("Missing doctor data for Medikit service. Please complete it or deactivate the service.")
      if(missingDoctorData) alert("Missing doctor required data to register in Medikit. (Check enrollment or MainSpecialty values)");

      return;
    }


    return this.doctorService.saveMedikitData(this.updatedUser.id, this.medikitData)
    .then(() => {
      alert("Successfully registered doctor")
      window.location.reload();
    })
    .catch((err)=>{
      return err && err._body ?
            (err._body.message ? alert(err._body.message) : alert(err))
            : alert(err);
    });
  }

  uploadMedikitFiles(evt: any) {
    let inputValue = evt.target;
    let file = inputValue.files[0];
    let fileType = inputValue.name;
    let fileName = file.name;

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    }).then( ( result:string ) => {

      let fileAsBase64 = result.substring(23);

      if(fileType == "idFile") {
        this.medikitData["documents"]["idFileName"] = fileName;
        this.medikitData["documents"]["idFile"] = fileAsBase64;
      } else if(fileType == "enrollmentFile") {
        this.medikitData["documents"]["enrollmentFileName"] = fileName;
        this.medikitData["documents"]["enrollmentFile"] = fileAsBase64;
      }
    })
    .catch(err => console.log(err));
  }

  missingMedikitData() {
    const required = [];

    return _.isEmpty(this.medikitData["country"])
        || _.isEmpty(this.medikitData["state"])
        || _.isEmpty(this.medikitData["billingAddress"])
        || _.isEmpty(this.medikitData["institution"])
        || _.isEmpty(this.medikitData["city"])
        || _.isEmpty(this.medikitData["postalCode"])
        || _.isEmpty(this.medikitData["mobilePhone"])
        || _.isEmpty(this.medikitData["birthDate"])
        || _.isEmpty(this.medikitData["documents"]["idFile"])
        || _.isEmpty(this.medikitData["documents"]["enrollmentFile"])
  }

  missingDoctorRequiredData() {
    return _.isEmpty(this.updatedUser.enrollment) || _.isEmpty(this.updatedUser.mainSpecialty)
  }

  toggleDoctorBanned() {
    return this.doctorService.setDoctorBannedStatus(this.user.id, !this.updatedUser.banned, this.needsAutomaticActivation)
    .then(() => {
      this.updatedUser.banned = !this.updatedUser.banned;
      this.updatedUser.banned ? alert("El doctor fue baneado") : alert("El doctor fue desbaneado");
    })
    .catch(() => {
      this.updatedUser.banned ? alert("Ocurrió un error al desbanear el doctor.") : alert("Ocurrió un error al banear al doctor.")
    })
  }
};



// WEBPACK FOOTER //
// ./src/app/doctors/detail/doctor-detail.component.ts